import { defineComponent as f, computed as c, capitalize as l, createElementBlock as a, createBlock as v, openBlock as o, createElementVNode as s, toDisplayString as d, Fragment as u, renderList as b, createCommentVNode as m, withModifiers as I, normalizeClass as w } from "vue";
import C from "./HeaderListbox.vue.js";
const B = {
  key: 0,
  class: "header-group"
}, E = { class: "header-group-label" }, N = { class: "header-group-items" }, V = {
  key: 0,
  class: "header-group-item"
}, A = ["href", "onClick"], L = {
  key: 1,
  class: "header-group-item"
}, F = ["href"], H = /* @__PURE__ */ f({
  __name: "HeaderItemGroup",
  props: {
    group: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    resolveInternalLinks: { type: Function },
    linkIsActive: { type: Function }
  },
  emits: ["navigate"],
  setup(n, { emit: p }) {
    const r = n, h = p, y = c(() => r.group.children.filter((e) => e.show || r.isEditable).filter(
      (e) => e.type === "guide" || e.type === "reference" || e.type === "link"
    ).map((e) => ({
      id: e.uid,
      label: e.title || l(e.type)
    }))), g = c(() => {
      const e = r.group.children.find((i) => r.linkIsActive(i));
      return e ? { id: e.uid, label: e.title || l(e.type) } : { id: "null", label: "null" };
    }), k = ({ id: e }) => {
      const i = r.group.children.find((t) => t.uid === e);
      (i?.type === "reference" || i?.type === "guide") && h("navigate", i.uid, i.type), i?.type === "link" && window.open(i.link, "_blank", "noopener noreferrer");
    };
    return (e, i) => n.isMobile ? (o(), a("div", B, [
      s("div", E, d(n.group.title || l(n.group.type)), 1),
      s("ul", N, [
        (o(!0), a(u, null, b(n.group.children, (t) => (o(), a(u, {
          key: t.uid
        }, [
          (t.type === "guide" || t.type === "reference") && (t.show || n.isEditable) ? (o(), a("li", V, [
            s("a", {
              class: w(["header-item-link", {
                "header-item-active": n.linkIsActive(t),
                "header-item-ghost": !t.show
              }]),
              href: n.resolveInternalLinks(t),
              onClick: I((M) => e.$emit("navigate", t.uid, t.type), ["prevent"])
            }, d(t.title || l(t.type)), 11, A)
          ])) : t.type === "link" && t.show ? (o(), a("li", L, [
            s("a", {
              class: "header-item-link",
              href: t.link || "#",
              rel: "noopener noreferrer",
              target: "_blank"
            }, d(t.title || l(t.type)), 9, F)
          ])) : m("", !0)
        ], 64))), 128))
      ])
    ])) : (o(), v(C, {
      key: 1,
      buttonClass: [n.linkIsActive(n.group) && "header-item-active"],
      buttonName: n.group.title || l(n.group.type),
      modelValue: g.value,
      options: y.value,
      static: "",
      "onUpdate:modelValue": k
    }, null, 8, ["buttonClass", "buttonName", "modelValue", "options"]));
  }
});
export {
  H as default
};
